import { ESaleType } from '../../../../../packages/api-models/common/json_query';
import { NonEmptyArray } from '../../../../../packages/JsonQuery';

interface IPrepareValueProps {
  value: NonEmptyArray<ESaleType> | null;
  allowedValues: ESaleType[];
}

export const prepareValue = ({ value, allowedValues }: IPrepareValueProps): (ESaleType | null)[] => {
  if (!value) {
    return [null];
  }

  const filtered = value.filter(item => allowedValues.includes(item));

  return filtered.length ? filtered : [null];
};
